
const y_end = 600
const lines = [200, 300, 550, 620]

const x_app = 920

const v5 = [lines[1], 50]
const lts = [lines[0], 480]
const hrv = [lines[0] - 20, 380]
const ulp_ldo = [lines[2], 150]
const ldo = [lines[2], 220]
const vsup = [lines[3], 70]
const isr = [lines[3], 10]
const de_bouncer = [lines[2] - 10, y_end - 165]
const hrv_low = de_bouncer[1] + 35
const bat_low = de_bouncer[1] + 55
const i2c = [lines[2], y_end - 100]
const tb = [lines[2] - 160, y_end - 310]
const vdd_sts = [v5[0] + 70, y_end]
const vdd_lts = [v5[0] + 10, y_end]
const vdd_usb = [100, 40]
const vdd_sol = [100, 205]
const vss1 = [660, y_end]
const vreg = [900, isr[1] + 25]
const dcdc = [165, vdd_sol[1] - 70]
const vdd_hrv = [100, 280]

const switch_line = vsup[0] + 50

const vsup_sw = [switch_line, ulp_ldo[1] - 10]
const vaux_sw = [
	[switch_line, ldo[1] - 10],
	[switch_line, ldo[1] + 30],
	[switch_line, ldo[1] + 70]
]

const gnd_sw = [
	[switch_line, ldo[1] + 110],
	[switch_line, ldo[1] + 150],
	[switch_line, ldo[1] + 190]
]

const device_json = [ 
	/****************************************************************************
	 * RED LINES
	 ***************************************************************************/
	{
		type : 'Route',
		color : 'red',
		route : {
			type : 'branch',
			from : [vdd_sts[0], v5[1]],
			to : vdd_sts,
			children : [
				{
					type : 'end',
					position : [tb[0] + 5, tb[1] + 130]
				},
				{
					type : 'end',
					position : [lts[0] + 5, lts[1] + 35]
				},
				{
					type : 'end',
					position : [lines[1], vdd_sol[1] + 10],
					marker : 'end'
				},
				{
					type : 'end',
					position : [v5[0] + 60, lts[1] + 60],
					marker : 'end'
				},
				{
					type : 'branch',
					position : vsup_sw,
					marker : 'end',
					children : [
						{
							type : 'end',
							position : [ulp_ldo[0] + 35, ulp_ldo[1]]
						},
						{
							type : 'branch',
							position : [ldo[0] - 10, vaux_sw[0][1]],
							children : [
								{
									type : 'branch',
									position : vaux_sw[0],
									marker : 'end',
									children : [
										{
											type : 'branch',
											position : [vaux_sw[2][0] - 40, vaux_sw[2][1]],
											children : [
												{
													type : 'end',
													marker : 'end',
													position : vaux_sw[1]
												},
												{
													type : 'end',
													marker : 'end',
													position : vaux_sw[2]
												}
											]
										},
										{
									type : 'end',
										position : [ldo[0] + 35, ldo[1]]
										}
									]
								}
							]
						}
					]
				}
			]
		}
	},
	/****************************************************************************
	 * BLUE LINES
	 ***************************************************************************/
	{
		type : 'Route',
		color : 'blue',
		route : {
			type : 'branch',
			from : [vdd_lts[0], v5[1]],
			to : vdd_lts,
			children : [
				{
					type : 'end',
					marker : 'end',
					position : [lines[1], vdd_sol[1]],
				},
				{
					type : 'end',
					marker : 'end',
					position : [v5[0] + 20, lts[1] + 60],
				},
				{
					type : 'end',
					position : [tb[0] + 5, tb[1] + 140]
				},
				{
					type : 'end',
					position : [lts[0] + 5, lts[1] + 25]
				},
			]
		}
	},
	/****************************************************************************
	 * ORANGE LINES
	 ***************************************************************************/
	{
		type : 'Route',
		color : 'orange',
		route : {
			type : 'branch',
			from : vdd_usb,
			to : [vdd_sts[0], vdd_usb[1]],
			children : [
				{
					type : 'end',
					marker : 'end',
					position : [vdd_lts[0], v5[1]]
				},
				{
					type : 'end',
					marker : 'end',
					position : [vdd_sts[0], v5[1]]
				}
			]
		}
	},
	/****************************************************************************
	 * GRAY LINES
	 ***************************************************************************/
	{
		type : 'Route',
		color : 'gray',
		route : {
			type : 'branch',
			from : [v5[0] - 30, vdd_sol[1]],
			to : vdd_sol,
			marker : 'end',
			children : [ ]
		}
	},
	{
		type : 'Route',
		color : 'gray',
		route : {
			type : 'route',
			from : [vdd_hrv[0] - 40, vdd_hrv[1]],
			to : [hrv[0], vdd_hrv[1]],
			children : [
				{
					type : 'branch',
					position : [hrv[0] - 30, lts[1] + 30],
					children : [
						{
							type : 'end',
							position : [ lts[0], lts[1] + 30 ]
						},
						{
							type : 'end',
							position : [ hrv[0], hrv[1] + 30 ]
						}
					]
				}
			]
		}
	},
	/****************************************************************************
	 * GRAY LINES GND
	 ***************************************************************************/
	{
		type : 'Route',
		color : 'gray',
		route : {
			type : 'branch',
			from : vss1,
			to : [vss1[0], vsup_sw[1] + 25],
			children : [
				{
					type : 'end',
					marker : 'end',
					position : [vsup_sw[0], vsup_sw[1] + 25]
				},
				{
					type : 'end',
					marker : 'end',
					position : [vaux_sw[0][0], vaux_sw[0][1] + 25]
				},
				{
					type : 'end',
					marker : 'end',
					position : [vaux_sw[1][0], vaux_sw[1][1] + 25]
				},
				{
					type : 'end',
					marker : 'end',
					position : [vaux_sw[2][0], vaux_sw[2][1] + 25]
				},
				{
					type : 'end',
					marker : 'end',
					position : [gnd_sw[0][0], gnd_sw[0][1] + 25]
				},
				{
					type : 'end',
					marker : 'end',
					position : [gnd_sw[1][0], gnd_sw[1][1] + 25]
				},
				{
					type : 'end',
					marker : 'end',
					position : [gnd_sw[2][0], gnd_sw[2][1] + 25]
				},
			]
		}
	},
	/****************************************************************************
	 * GRAY LINE ISR
	 ***************************************************************************/
	{
		type : 'Route',
		color : 'gray',
		route : {
			from : [isr[0] + 5, vreg[1]],
			to : vreg,
			children : []
		}
	},
	/****************************************************************************
	 * GREEN LINES
	 ***************************************************************************/
	{
		type : 'Route',
		color : 'green',
		route : {
			from : [vsup_sw[0] + 30, vsup_sw[1] + 10],
			to : [x_app, vsup_sw[1] + 10],
			marker : 'end',
			children : []
		}
	},
	{
		type : 'Route',
		color : 'green',
		route : {
			from : [ulp_ldo[0] + 30, ulp_ldo[1] + 10],
			to : [ulp_ldo[0] + 100, ulp_ldo[1] + 10],
			marker : 'end',
			children : [
				{
					type : 'route',
					position : [ulp_ldo[0] + 100, vsup_sw[1] + 9],
					children : [
						{
							type : 'end',
							marker : 'end',
							position : [vsup_sw[0], vsup_sw[1] + 9]
						}
					]
				}
			]
		}
	},
	/****************************************************************************
	 * PURPLE LINES
	 ***************************************************************************/
	...vaux_sw.map((sw) => {
		return {
			type : 'Route',
			color : 'purple',
			route : {
				from : [sw[0] + 30, sw[1] + 10],
				to : [x_app, sw[1] + 10],
				marker : 'end',
				children : []
			}
		}
	}),

	...vaux_sw.map((sw) => {
		const i = vaux_sw.findIndex((s) => s === sw)
		return {
			type : 'Route',
			color : 'purple',
			route : {
				from : [ldo[0] + 10, ldo[1] + 10 + i * 13],
				to : [ldo[0] + 95 - 5 * i, ldo[1] + 10 + i * 13],
				marker : 'end',
				children : [
					{
						type : 'branch',
						position : [ldo[0] + 95 - 5 * i, sw[1] + 9],
						children : [
							{
								type : 'end',
								marker : 'end',
								position : [sw[0], sw[1] + 9]
							}
						]
					}
				]
			}
		}
	}),

	...gnd_sw.map((sw) => {
		return {
			type : 'Route',
			color : 'purple',
			route : {
				from : [sw[0] + 30, sw[1] + 10],
				to : [x_app, sw[1] + 10],
				marker : 'end',
				children : []
			}
		}
	}),
	/****************************************************************************
	 * GRAY ARROW DE BOUNCER
	 ***************************************************************************/
	{
		type : 'Route',
		color : 'gray',
		route : {
			from : [tb[0] + 135, de_bouncer[1] + 15],
			to : [x_app, de_bouncer[1] + 15],
			marker : 'arrow',
			children : []
		}
	},
	/****************************************************************************
	 * GRAY ARROW HRV_LOW AND BAT_LOW
	 ***************************************************************************/
	{
		type : 'Route',
		color : 'gray',
		route : {
			from : [x_app - 5, hrv_low],
			to : [tb[0] + 120, hrv_low],
			marker : 'arrow',
			children : []
		}
	},
	{
		type : 'Route',
		color : 'gray',
		route : {
			from : [x_app - 5, bat_low],
			to : [tb[0] + 120, bat_low],
			marker : 'arrow',
			children : []
		}
	},
	/****************************************************************************
	 * GRAY ARROW HRV
	 ***************************************************************************/
	{
		type : 'Route',
		color : 'gray',
		route : {
			type : 'branch',
			marker : 'arrow',
			from : [tb[0] - 10, hrv[1] + 30],
			to : [hrv[0] + 120, hrv[1] + 30],
			children : []
		}
	},
	{
		type : 'Route',
		color : 'gray',
		route : {
			type : 'branch',
			marker : 'arrow',
			to : [tb[0] - 10, hrv[1] + 30],
			from : [hrv[0] + 120, hrv[1] + 30],
			children : []
		}
	},
	/****************************************************************************
	 * GRAY ARROW ALWAYS CONNECTED SWITCH
	 ***************************************************************************/
	{
		type : 'Route',
		color : 'gray',
		route : {
			type : 'branch',
			from : [v5[0] + 40, hrv[1] + 60],
			to : [tb[0], hrv[1] + 60],
			children : [
				{
					type : 'end',
					marker : 'arrow',
					position : [v5[0] + 40, lts[1] + 40]
				}
			]
		}
	},
	/****************************************************************************
	 * GRAY ARROW VSUP
	 ***************************************************************************/
	{
		type : 'Route',
		color : 'gray',
		route : {
			type : 'branch',
			from : [vsup_sw[0] + 15, vsup_sw[1] - 10],
			to : [vsup_sw[0] + 15, vsup[1] + 10],
			marker: 'arrow',
			children : []
		}
	},

	/****************************************************************************
	 * GRAY ARROW I2C OR SPI
	 ***************************************************************************/
	{
		type : 'Route',
		color : 'gray',
		route : {
			type : 'branch',
			from : [tb[0] + 130, i2c[1] + 10],
			to : [x_app, i2c[1] + 10],
			children : []
		}
	},
	{
		type : 'Route',
		color : 'gray',
		route : {
			type : 'branch',
			from : [tb[0] + 135, i2c[1] + 30],
			to : [x_app, i2c[1] + 30],
			marker : 'arrow',
			children : []
		}
	},
	{
		type : 'Route',
		color : 'gray',
		route : {
			type : 'branch',
			from : [tb[0] + 135, i2c[1] + 50],
			to : [x_app, i2c[1] + 50],
			marker : 'arrow',
			children : []
		}
	},
	{
		type : 'Route',
		color : 'gray',
		route : {
			type : 'branch',
			from : [tb[0] + 135, i2c[1] + 70],
			to : [x_app, i2c[1] + 70],
			marker : 'arrow',
			children : []
		}
	},
	/****************************************************************************
	 * ACR ARROWS
	 ***************************************************************************/

	{
		type : 'Route',
		color : 'gray',
		route : {
			type : 'branch',
			from : [tb[0], tb[1] + 20],
			to : [v5[0] - 15, tb[1] + 20],
			children : [
				{
					type : 'end',
					position : [v5[0] - 15, vdd_sol[1] + 20],
					marker : 'arrow'
				}
			]
		}
	},

	{
		type : 'Route',
		color : 'gray',
		route : {
			type : 'branch',
			from : [tb[0] + 30, tb[1]],
			to : [tb[0] + 30, ulp_ldo[1] + 25],
			children : [
				{
					type : 'end',
					position : [ulp_ldo[0] - 5, ulp_ldo[1] + 25],
					marker : 'arrow'
				}
			]
		}
	},

	{
		type : 'Route',
		color : 'gray',
		route : {
			type : 'branch',
			from : [tb[0] + 80, tb[1]],
			to : [tb[0] + 80, ldo[1] + 25],
			children : [
				{
					type : 'end',
					position : [ldo[0] - 5, ldo[1] + 25],
					marker : 'arrow'
				}
			]
		}
	},

	/****************************************************************************
	 * BORDER BOXES
	 ***************************************************************************/
	{
		type : 'BorderBox',
		position : vdd_usb
	},
	{
		type : 'BorderBox',
		position : vdd_sol
	},
	{
		type : 'BorderBox',
		position : vdd_lts
	},
	{
		type : 'BorderBox',
		position : vdd_sts
	},
	{
		type : 'BorderBox',
		position : vss1
	},
	{
		type : 'BorderBox',
		position : [900, bat_low]
	},
	{
		type : 'BorderBox',
		position : [900, hrv_low]
	},
	{
		type : 'BorderBox',
		position : [900, vsup_sw[1] + 10]
	},
	{
		type : 'BorderBox',
		position : [900, isr[1] + 25]
	},
	{
		type : 'BorderBox',
		position : [900, de_bouncer[1] + 15]
	},
	{
		type : 'BorderBox',
		position : vdd_hrv
	},

	...vaux_sw.map((sw) => {
		return {
			type : 'BorderBox',
			position : [900, sw[1] + 10]
		}
	}),

	...gnd_sw.map((sw) => {
		return {
			type : 'BorderBox',
			position : [900, sw[1] + 10]
		}
	}),

	...[10, 30, 50, 70].map((i) => {
		return {
			type : 'BorderBox',
			position : [900, i2c[1] + i]
		}
	}),

	{
			type : 'BorderBox',
			position : [100, 400]
	},

	/****************************************************************************
	 * CIRCLES
	 ***************************************************************************/

	{
		type : 'Circle',
		position : [vsup_sw[0] + 3, vsup_sw[1] + 17]
	},
	{
		type : 'Circle',
		position : [v5[0] + 57, lts[1] + 45]
	},

	...vaux_sw.map((sw) => {
		return {
			type : 'Circle',
			position : [sw[0] + 3, sw[1] + 17]
		}
	}),

	...gnd_sw.map((sw) => {
		return {
			type : 'Circle',
			position : [sw[0] + 3, sw[1]]
		}
	}),

	/****************************************************************************
	 * STATIC TEXT
	 ***************************************************************************/
	{
		type : 'Text',
		position : [890, de_bouncer[1] + 11],
		text : 'WAKE_UP',
		textAnchor : 'end'
	},
	{
		type : 'Text',
		position : [890, bat_low - 4],
		text : 'bat_low',
		textAnchor : 'end'
	},
	{
		type : 'Text',
		position : [890, hrv_low - 4],
		text : 'hrv_low',
		textAnchor : 'end'
	},
	{
		type : 'Text',
		position : [890, vsup_sw[1] + 5],
		text : 'VSUP',
		textAnchor : 'end'
	},
	{
		type : 'Text',
		position : [890, vreg[1] - 4],
		text : 'VREG',
		textAnchor : 'end'
	},
	{
		type : 'Text',
		position : [vdd_usb[0] + 10, vdd_usb[1] - 4],
		text : 'VDD_USB',
	},
	{
		type : 'Text',
		position : [vdd_sol[0] + 10, vdd_sol[1] - 4],
		text : 'LX1',
	},
	{
		type : 'Text',
		position : [vdd_hrv[0] + 10, vdd_hrv[1] - 4],
		text : 'VDD_HRV',
	},
	{
		type : 'Text',
		position : [vdd_sol[0] + 10, 404],
		text : 'VSS_DCDC',
	},
	{
		type : 'Text',
		position : [vdd_lts[0] - 10, vdd_lts[1] - 5],
		text : 'VDD_LTS',
		textAnchor : 'end'
	},
	{
		type : 'Text',
		position : [vdd_sts[0] + 10, vdd_sts[1] - 5],
		text : 'VDD_STS',
		textAnchor : 'start'
	},
	{
		type : 'Text',
		position : [vss1[0] + 10, vss1[1] - 5],
		text : 'VSS1',
		textAnchor : 'start'
	},

	...[[10, 'MISO'], [30, 'MOSI_SDA'], [50, 'SCL'], [70, 'CS']].map((i) => {
		return {
			type : 'Text',
			position : [890, i2c[1] + i[0] - 2],
			text : i[1],
			textAnchor : 'end'
		}
	}),

	...vaux_sw.map((sw) => {
		const i = vaux_sw.findIndex(s => s === sw)
		return {
			type : 'Text',
			position : [890, sw[1] + 5],
			text : `VAUX [${i}]`,
			textAnchor : 'end'
		}
	}),

	...gnd_sw.map((sw) => {
		const i = gnd_sw.findIndex(s => s === sw)
		return {
			type : 'Text',
			position : [890, sw[1] + 5],
			text : `VAUX_GND [${i}]`,
			textAnchor : 'end'
		}
	}),

	/****************************************************************************
	 * BOXES
	 ***************************************************************************/
	{
		type : 'Box',
		position : v5,
		size : [80, 70],
		lines : ["USB", "5V", "Charging"]
	},
	{
		type : 'Box',
		position : lts,
		size : [90, 70],
		lines : ["LTS/STS/", "HRV", "supervisory"]
	},
	{
		type : 'Box',
		position : ulp_ldo,
		size : [70, 50],
		lines : ["ULP LDO"]
	},
	{
		type : 'Box',
		position : ldo,
		size : [70, 50],
		lines : ["LDO"]
	},
	{
		type : 'Box',
		position : vsup,
		size : [120, 50],
		lines : ["VSUP", "Sleep Counter"]
	},
	{
		type : 'Box',
		position : isr,
		size : [120, 50],
		lines : ["Internal supply", "regulator"]
	},
	{
		type : 'Box',
		position : de_bouncer,
		size : [120, 30],
		lines : [""]
	},
	{
		type : 'Box',
		position : i2c,
		size : [100, 80],
		lines : ["I2C or SPI", "interface"]
	},
	{
		type : 'Box',
		position : hrv,
		size : [110, 70],
		lines : ["HRV current", "measurement", "aka lux-meter"]
	},
	{
		type : 'Box',
		position : [1, vdd_sol[1] - 15],
		size : [50, 30],
		lines : ["HRV"]
	},
	{
		type : 'TrippleBox',
		position : tb,
		size : [130, 290],
		lines : [
			["Application", "Supply", "Control"],
			["Control", "Unit"],
			["Registers", "E2PROM"]
		]
	},
	{
		type : 'TrippleBox',
		position : dcdc,
		size : [100, 190],
		lines : [
			["MPPT", "Controller"],
			["Boost", "Controller"],
			["Cold-start", "Booster"]
		]
	},
	{
		type : 'RBox',
		position : [x_app, 100],
		size : [70, 500],
		lines : "Application"
	}
]

export { device_json }
